import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import DownloadCTA from '../DownloadCTA';
import Footer from '../Footer';
import IconButton from '../IconButton';
import MainNav from '../MainNav';
import OnboardingHero from '../OnboardingHero';
import PropTypes from 'prop-types';
import { SolarPanelSmall } from '../Styled';
import { getUserMpans } from '../../api/SmartMeter';
import logo from '../../assets/svg/loop-logo.svg';
import smoothScroll from '../../utils/smoothScroll';
import styled from 'styled-components';

const SideBarCol = styled(Col)`
  border-right: #afb6b9 1px solid;
`;

const MainContentCol = styled(Col)`
  background: #f5f5f5;
`;

const StyledContainer = styled(Container)`
  min-height: 100vh;
`;

const StyledNavbarBrand = styled(Navbar.Brand)`
  padding-left: 22px;
  padding-top: 0;
`;

const StyledSpacer = styled.div``;

const AppLayout = ({ children, hideDownload, hideSidebar, background }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOnboarded, setIsOnboarded] = useState(true);

  useEffect(() => {
    getUserMpans().then(userMpans => setIsOnboarded(!!userMpans?.length));
    if (!!window.location.hash) {
      const targetId = window.location.hash.split('#')[1];
      // Delay by 100ms so the page has a chance to render
      setTimeout(() => smoothScroll(targetId), 100);
    }
  }, []);

  return (
    <StyledContainer
      fluid
      className={`d-flex flex-column standard-layout ${
        background ? background : 'background-app-gradient'
      }`}>
      <Row>
        <Col className="p-0">
          <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
            <StyledNavbarBrand href="/">
              <img src={logo} alt="Loop Energy" />
            </StyledNavbarBrand>
            <MainNav navigate={navigate} />
          </Navbar>
        </Col>
      </Row>
      {!isOnboarded && (
        <Row>
          <OnboardingHero />
        </Row>
      )}
      <Row className="d-flex justify-content-center p-0 flex-fill">
        <Container fluid="xl" className="flex-fill">
          <Row className="h-100">
            {!hideSidebar && (
              <SideBarCol
                xs={0}
                sm={5}
                md={4}
                lg={4}
                className="p-1 p-sm-2 p-md-3 p-lg-4 d-none d-lg-flex bg-white flex-column h-100">
                <div>
                  <IconButton
                    href="/account/overview#account-overview"
                    label="Account overview"
                    textshort="Account"
                    icon="overview"
                    onClick={e => smoothScroll('account-overview')}
                  />
                  <IconButton
                    href="/account/overview#smart-meter-details"
                    label="My Smart Meter"
                    textshort="Smart Meter"
                    icon="smart-meter"
                    onClick={e => smoothScroll('smart-meter-details')}
                  />
                  <IconButton
                    href="/account/overview#delete-account"
                    label="Delete Account"
                    textshort="Delete Account"
                    icon="delete-account"
                    onClick={e => smoothScroll('delete-account')}
                  />
                  <IconButton
                    href="/account/overview#faq-and-support"
                    label="FAQ &amp; Support"
                    textshort="FAQ"
                    icon="help"
                    onClick={e => smoothScroll('faq-and-support')}
                  />
                </div>
                <div className="d-flex flex-column h-100 justify-content-between">
                  <StyledSpacer />
                  <SolarPanelSmall />
                </div>
              </SideBarCol>
            )}
            <MainContentCol className="p-1 p-sm-2 p-md-3 p-lg-4">
              {children}
            </MainContentCol>
          </Row>
        </Container>
      </Row>
      {!hideDownload && (
        <Row className="d-flex justify-content-center p-0 app-cta-space appstore-footer">
          <>
            <DownloadCTA />
            <Container fluid="xl" className="app-cta-space">
              <Row className="h-100">
                <SideBarCol
                  xs={0}
                  sm={5}
                  md={4}
                  lg={4}
                  className="p-1 p-sm-2 p-md-3 p-lg-4 d-none d-lg-block"
                />
                <MainContentCol className="p-1 p-sm-2 p-md-3 p-lg-4" />
              </Row>
            </Container>
          </>
        </Row>
      )}
      <Footer location={location} />
    </StyledContainer>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hideDownload: PropTypes.bool,
  hideSidebar: PropTypes.bool,
  background: PropTypes.string,
};

export default AppLayout;
